/**
 * 付款确认|保证金充值|通过并打款|保证金退款 模态框
 * props: isShow       {boolean}      是否展示模态框
 *        price        {number}       合手价|退款金额 [充值和分批通过并打款的时候不传，其他必填]
 *        orderId      {string}       订单编号|用户id 充值退款以及提现退款使用传入值为用户id，确认付款的时候传入值为收款单号，其他传入值为订单编号
 *        onCancel     {function}     取消的回调
 *        onOk         {function}     确定的回调
 *        isSeller[可选]{boolean}      是否是卖家，充值退款等需要判断
 *        params[可选]  {object}       调用接口的时候需要传的参数，一期参数均分散处理了，二期增加一个集中处理的入口，
 *                                     这样如果需求变更导致传递的参数变更的话，可以直接通过这个来传递；
 *        type  [可选]  {enum}         'confirm'|'charge'|'pass'|'refund'|'applyRefund'|'part_pass'
 *                                     付款确认|保证金充值|通过并打款|保证金退款|提现管理的保证金退款|分批操作的通过并打款
 *                                     不传的话，默认为'confirm'
 *
 */
import React, { Component } from 'react';
import { Modal, Form, Input, Radio, Icon } from 'antd';
import styled from 'styled-components';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { CHECK_Money, CHECK_num_letter } from '@/shared/reqexp';
import { dealValueShow, thousandBitSeparator } from '@/shared/functions';
const Tip = styled.div `
  color: #ff4040;
  font-size: 12px;
  padding: 10px 0 0 0;
`;
const tip = {
    color: '#ff4040',
};
const mapStateToProps = (rootState) => ({
    _state: rootState.payMoneyModal,
});
class PayMoney extends Component {
    constructor() {
        super(...arguments);
        this.onOk = () => {
            dispatch.payMoneyModal.onOk(this.props);
        };
        this.onCancel = () => {
            dispatch.payMoneyModal.onCancel(this.props);
        };
        this.radioChange = (e) => {
            dispatch.payMoneyModal.radioChange({ props: this.props, v: e.target.value });
        };
        this.checkLen = (rule, value, callback) => {
            dispatch.payMoneyModal.checkLen({ props: this.props, value, callback });
        };
        this.checkSub = (rule, value, callback) => {
            dispatch.payMoneyModal.checkSub({ props: this.props, value, callback });
        };
        this.getName = (type) => {
            switch (type) {
                case 'confirm':
                    return { _title: '付款确认', _moneyName: '付款金额' };
                case 'charge':
                    return { _title: '保证金充值', _moneyName: '充值金额' };
                case 'pass':
                case 'part_pass':
                    return { _title: '通过并打款', _moneyName: '打款金额' };
                case 'refund':
                case 'applyRefund':
                    return { _title: '保证金退款', _moneyName: '退款金额' };
                default:
                    return { _title: '付款确认', _moneyName: '付款金额' };
            }
        };
        this.getMoney = (p) => {
            return dealValueShow(thousandBitSeparator(p === undefined ? '' : p));
        };
        this.isAddChange = (e) => {
            this.props.form.setFieldsValue({ isAdd: e.target.value });
            dispatch.payMoneyModal.computeMoney({
                price: this.props.price, props: this.props
            });
        };
        this.isShowChange = () => {
            dispatch.payMoneyModal.SET_SHOW_CHANGE_MONEY();
        };
        this.computeMoney = (e) => {
            this.props.form.setFieldsValue({ dealMoney: e.target.value });
            dispatch.payMoneyModal.computeMoney({
                price: this.props.price, props: this.props
            });
        };
        this.isHigherPartPassMoney = (e) => {
            this.props.form.setFieldsValue({ partPassMoney: e.target.value });
            dispatch.payMoneyModal.isHigherPartPassMoney(this.props);
        };
    }
    render() {
        const { isShow, price, type } = this.props;
        const { radios, flowWater, desc, notPrice, noteTip, m_radios, showChangeMoney, afterMoney, shoudPayPrice, shoudPayDesc, higherPartPassMoney, } = this.props._state;
        const { _title, _moneyName } = this.getName(type);
        const { getFieldDecorator } = this.props.form;
        const _tip = (type === 'refund' || type === 'applyRefund') ? '请确认卖家已退款项再做确认。' : type === 'part_pass' && higherPartPassMoney ? '打款金额超过实际出售价格，请确认。' : '请确认买家已缴纳款项再做确认。';
        const _icon = showChangeMoney ? 'up' : 'down';
        const priceAndDesc = dealValueShow(thousandBitSeparator(shoudPayPrice), '元') + (shoudPayDesc ? `(${shoudPayDesc})` : '');
        const _price = this.getMoney(price);
        const _afterMoney = this.getMoney(afterMoney ? afterMoney : price);
        return (<Modal title={_title} visible={isShow} onOk={this.onOk} onCancel={this.onCancel}>
            <Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} labelAlign="left">
                <Form.Item label={_moneyName}>
                   {type === 'charge' && getFieldDecorator('money', {
            rules: [
                { required: true,
                    message: '请输入正确的金额数字',
                    pattern: CHECK_Money },
            ],
        })(<Input placeholder={'请输入保证金充值'} style={{ width: 200, marginRight: 10 }}/>)}
                   {type !== 'charge' && type !== 'part_pass' && <span className="ant-form-text">{_price}</span>}
                   {type !== 'part_pass' && <span className="ant-form-text">元</span>}
                   {type === 'part_pass' &&
            <span className="ant-form-text">
                      {priceAndDesc}
                    </span>}
                </Form.Item>
                <Form.Item label="方式">
                   {getFieldDecorator('way', { initialValue: '1' })(<Radio.Group onChange={this.radioChange}>
                           {radios.map((r, i) => (<Radio key={`radio_${i}`} value={r.value}>{r.key}</Radio>))}
                       </Radio.Group>)}
                </Form.Item>
                {flowWater &&
            <Form.Item wrapperCol={{ span: 20, offset: 4 }} style={{ marginTop: -20 }}>
                        {getFieldDecorator('desc', {
                rules: [
                    { required: flowWater, message: desc },
                    { pattern: CHECK_num_letter, message: '流水号只能是字母和数字' },
                ],
            })(<Input placeholder={desc}/>)}
                    </Form.Item>}
                {type !== 'applyRefund' && type !== 'refund' &&
            <Form.Item label="备注">
                        {getFieldDecorator('note', {
                rules: [
                    { validator: this.checkLen },
                    { required: notPrice,
                        message: '  ',
                    },
                ],
            })(<Input.TextArea placeholder={noteTip} style={{ height: '88px', resize: 'none' }}/>)}
                  </Form.Item>}
                {(type === 'pass' || type === 'part_pass') &&
            <div>
                      <div style={{ marginBottom: 20 }}>
                        不是以上金额，需更改
                        <Icon type={_icon} style={{ marginLeft: 8, fontSize: 16, color: '#999' }} onClick={this.isShowChange}/>
                      </div>
                      {type === 'pass' &&
                <div style={{ display: showChangeMoney ? 'block' : 'none' }}>
                          
                          <Form.Item 
                // wrapperCol={{ span: 20 , offset: 4 }}
                label="扣减金额">
                            {getFieldDecorator('dealMoney', {
                    rules: [
                        { required: false,
                            message: '请输入正确的金额数字',
                            pattern: CHECK_Money },
                        {
                            validator: this.checkSub,
                        },
                    ],
                })(<Input placeholder="请输入数字" style={{ width: 200, marginRight: 10 }} onChange={this.computeMoney} suffix={<span className="ant-form-text" style={{ color: '#999999' }}>元</span>}/>)}
                          </Form.Item>
                          <Form.Item wrapperCol={{ span: 20, offset: 4 }}>
                            <span className="ant-form-text">更改后金额：</span>
                            <span className="ant-form-text">{_afterMoney}</span>
                            <span className="ant-form-text">元</span>
                          </Form.Item>
                        </div>}
                      {type === 'part_pass' &&
                <div style={{ display: showChangeMoney ? 'block' : 'none' }}>
                          <Form.Item label="打款金额">
                            {getFieldDecorator('partPassMoney', {
                    rules: [
                        { required: false,
                            message: '请输入正确的金额数字',
                            pattern: CHECK_Money },
                    ],
                })(<Input placeholder="请输入数字" style={{ width: 200, marginRight: 10 }} onChange={this.isHigherPartPassMoney} suffix={<span className="ant-form-text" style={{ color: '#999999' }}>元</span>}/>)}
                          </Form.Item>
                        </div>}
                    </div>}
            </Form>
            <Tip>提示：{_tip}</Tip>
        </Modal>);
    }
}
PayMoney.defaultProps = {
    type: 'confirm',
};
const Pay = Form.create()(PayMoney);
export default connect(mapStateToProps)(Pay);
